var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactGoogleLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.733,
    height: 24,
    viewBox: "0 0 16.733 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g842",
    transform: "translate(-583.3 52.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path835",
    d: "M620.6-3.215a23.284,23.284,0,0,1,1.891,2.793,14.6,14.6,0,0,1,1.038,2.632c.21.606.408.791.828.791.457,0,.667-.309.828-.791a14.853,14.853,0,0,1,1-2.583,28.9,28.9,0,0,1,2.805-3.967,24.546,24.546,0,0,0,2.781-4,9.75,9.75,0,0,0,.952-4.239,8.427,8.427,0,0,0-.939-3.918l-2.719.729-1.656,4.35-.408.593-.087.111-.111.136-.185.222-.272.272-1.471,1.2-3.67,2.126Z",
    transform: "translate(-32.69 -31.902)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path833",
    d: "M589.9,4.243c.9,2.051,2.62,3.843,3.794,5.425L599.91,2.3a3.263,3.263,0,0,1-2.459,1.149,3.183,3.183,0,0,1-3.2-3.188,3.41,3.41,0,0,1,.729-2.064L590.765-.675Z",
    transform: "translate(-5.784 -44.785)",
    fill: "#fbbc04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path831",
    d: "M636.005-49.8a8.3,8.3,0,0,1,4.894,4.128l-4.968,5.92a3.454,3.454,0,0,0,.729-2.064A3.22,3.22,0,0,0,633.472-45,3.346,3.346,0,0,0,631-43.868V-47.6Z",
    transform: "translate(-41.805 -2.717)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path829",
    d: "M599.1-49.909a8.3,8.3,0,0,1,6.389-2.991,8.543,8.543,0,0,1,2.546.383l-4.993,5.932h-3.535Z",
    transform: "translate(-13.847 0)",
    fill: "#1a73e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path827",
    d: "M584.116-19.245A9.566,9.566,0,0,1,583.3-23.2a8.321,8.321,0,0,1,1.965-5.4l3.942,3.324Z",
    transform: "translate(0 -21.297)",
    fill: "#ea4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactGoogleLocation);
export default __webpack_public_path__ + "static/media/contact_googleLocation.30777c7fd0aa8f3c21cfe082464559e8.svg";
export { ForwardRef as ReactComponent };